// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import CarouselResponsive from '@tcp/core/src/components/common/molecules/Carousel/views/CarouselResponsive';

export default css`
  && .link-text {
    margin-bottom: 0;
  }
`;

const StyledSlider = styled(CarouselResponsive)`
  .control-arrow.control-prev,
  .control-arrow.control-next,
  .control-dots,
  .tcp_carousel__play_pause_button {
    display: none;
  }
`;

const StyledContainer = styled.div`
  width: 100%;
  position: relative;
`;

const ColorContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    padding-bottom: 4px;
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding: 8px 0;
  }
  ${(props) => (props.colorData ? `background-color: ${props.colorData.color};` : '')}
`;

const StyledMarqueeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;

const ImageContainer = styled.div`
  position: relative;
  text-align: center;

  .slider-content-innerText {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }
`;

export { StyledContainer, ColorContainer, ImageContainer, StyledSlider, StyledMarqueeContainer };
